import { render, staticRenderFns } from "./CustomerPurchase.vue?vue&type=template&id=511c23c4&scoped=true"
import script from "./CustomerPurchase.vue?vue&type=script&lang=ts"
export * from "./CustomerPurchase.vue?vue&type=script&lang=ts"
import style0 from "./CustomerPurchase.vue?vue&type=style&index=0&id=511c23c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511c23c4",
  null
  
)

export default component.exports